import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Tecnologia } from 'src/app/models/Tecnologia';
import { GenericDialogComponent } from '../../shared/generic-dialog/generic-dialog.component';

import { StepperServiceService } from '../../shared/services/stepper-service.service';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { CatalogComponent } from '../catalog/catalog.component';
import { ConfigurationComponent } from '../configuration/configuration.component';
import { MacroactivityComponent } from '../macroactivity/macroactivity.component';
import { TechnologyComponent } from '../technology/technology.component';
import { TipoProjetoComponent } from '../tipo-projeto/tipo-projeto.component';
import { ProjectRiskComponent } from '../project-risk/project-risk.component';
import { DataService } from '../../shared/services/data.service';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import { UsersComponent } from '../users/users.component';
import { UsersService } from '../../shared/services/users.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { SubTasksComponent } from '../sub-tasks/sub-tasks.component';
import { AuthService } from '../../shared/services/auth.service';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { getCatalogErrorMessages } from 'src/app/constants/catalog-error-messages';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { CatalogService } from '../../shared/services/catalog.service';
import { ProfileService } from '../../shared/services/profile.service';
import { Profile } from 'src/app/models/Profile';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Permission } from '../../shared/security/permission';
import { CatalogState } from 'src/app/models/CatalogState';



@Component({
  standalone: false,
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css']
})
export class StepperComponent implements OnInit {
  @Output() valueChange = new EventEmitter<boolean>(); // Defina como boolean
  @ViewChild('stepper') stepper?: MatStepper;

  get showEditHeader(): boolean {
    return !!this.selectedTech && (this.stepper?.selectedIndex ?? 0) > 0;
  }

  get showBackArrow(): boolean {
    return this.showEditHeader;
  }

  forwardValue(value: boolean) {
    this.valueChange.emit(value);
  }

  Permission = Permission;
  variables: any;

  item: any;

  isCatalogUser: boolean = false;
  canEditCatalog: boolean = false; // Backend-provided flag indicating if user can edit this catalog
  isStepperReset: boolean = false;
  isCatalogInUse: boolean = false;

  // Toogle to check if the user is adding a new technology or updating an existing one.
  //This is important because it will determine which type of request it will send to the back-end
  isNewTechnology: boolean = false;

  //Indicates the name of the selected technology. It has a default value to be displayed.
  //selectedTech: string = this.variables.estimatorBackOffice;
  selectedTech: string = '';
  selectedName: string = '';
  selectedRegion: string = '';

  costCenter: string = '';

  macroTypes: any[] = [];
  profiles: Profile[] = [];

  //This Tecnologia object is passed from the child and carries all the information of a selected technology to edit or to be imported as config.
  selectedTechnology: any = {
    technology: '',
    name: '',
    region: '',
    costCenter: '',
    state: CatalogState.INCOMPLETE,
    catalogType: '',
    users: [],
    projectRisks: [],
    projectTypes: [],
    configurations: [],
    parameters: [],
    macroActivities: [],
    actionItems: [],
    actionTypes: [],
    subTasks: []
  };


  // One form group for each step
  formGroup0: any;
  formGroup1: any;
  formGroup2: any;
  formGroup3: any;
  formGroup4: any;
  formGroup5: any;
  formGroup6: any;
  formGroup7: any;
  // ----
  step = 0; //Indicate current step


  isFormValid = false; //Indicate that the form is not valid yet, so it wont show up the next button.

  //List for each section.
  projectRiskArr: any[] = []
  projectTypeArr: any[] = []
  usersArr: any[] = []
  configurationArr: any[] = []
  macroActivitiesArr: any[] = []
  actionItemsArr: any[] = [];
  paramsArr: any[] = [];
  actionTypeArr: any[] = [];
  subTasksArr: any[] = [];


  //The technology object that will be sent to the data base. It will be created a new document inside Mongo DB
  technologyDocument: any;
  userTechnologies: any;

  //Indicate if the section is valid. It needs at least one item created.
  isSectionsValid: boolean = true;
  //Error message to be displayed in case the section is not valid
  errorMessage: string = '';
  state: CatalogState = CatalogState.INCOMPLETE;

  errorMessages: any;

  private createEmptySelectedTechnology() {
    return {
      technology: '',
      name: '',
      region: '',
      costCenter: '',
      state: CatalogState.INCOMPLETE,
      catalogType: '',
      users: [],
      projectRisks: [],
      projectTypes: [],
      configurations: [],
      parameters: [],
      macroActivities: [],
      actionItems: [],
      actionTypes: [],
      subTasks: []
    };
  }


  constructor(private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public authService: AuthService,
    private route: ActivatedRoute,
    private service: StepperServiceService,
    private stepperService: StepperServiceService,
    private technologyService: TecnologiasService,
    public dialog: MatDialog,
    private dataService: DataService,
    private catalogService: CatalogService,
    private router: Router,
    private technologiesManagementService: TechnologiesManagementService,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService,
    private projectTypesService: ProjectTypesService,
    private profileService: ProfileService,
    private UsersManagementService: UsersManagementService,
    private usersService: UsersService) { }




  ngOnInit() {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.errorMessages = getCatalogErrorMessages(this.variables);
    });


    this.dataService.setEstimate({});
    // Initialize all the form groups
    this.formGroup0 = this._formBuilder.group({
    });
    this.formGroup1 = this._formBuilder.group({
    });
    this.formGroup2 = this._formBuilder.group({
    });
    this.formGroup3 = this._formBuilder.group({
    });
    this.formGroup4 = this._formBuilder.group({
    });
    this.formGroup5 = this._formBuilder.group({
    });
    this.formGroup6 = this._formBuilder.group({
    });
    this.formGroup7 = this._formBuilder.group({
    });

    //Listen to a change on form group 1. In case one element is selected the form is valid.
    this.formGroup0.statusChanges.subscribe(
      (result: any) => {
        if (result === 'VALID') this.isFormValid = true;
        else this.isFormValid = false;
      }
    );

    // //Listen to a change for the selected tech
    this.stepperService.dataChange.subscribe((data: any) => {

      if (data.name) {
        this.selectedName = data.name;
      }
      if (data.technology) {
        this.selectedTech = data.technology;
      }
      if (data.region) {
        this.selectedRegion = data.region;
      }
      if (data.costCenter) {
        this.costCenter = data.costCenter;
      }
    })

    this.profileService.getAllProfiles().subscribe(
      (profiles: Profile[]) => this.profiles = profiles,
      (err: any) => console.error('Error loading profiles', err)
    );


  }

  checkCatalogUser(users: any) {
    let currentUser: any;

    this.authService.getUserData().subscribe(userData => {
      currentUser = userData
    });


    users.find((user: any) => {
      if (user.email === currentUser.email) {
        this.isCatalogUser = true;
        return
      }
      else {
        this.isCatalogUser = false;
      }
    })
  }

  //Increase step counter and pass the data from one step to the service.
  onSubmit(value: any) {
    if (value.formGroup0.firstCtrl) {
      this.service.setData(value.formGroup0.firstCtrl);
      this.selectedName = value.formGroup0.firstCtrl;
    }
  }

  goToPreviousStep(stepper?: MatStepper) {
    if (stepper) {
      if (stepper.selectedIndex > 0) {
        stepper.previous();
      }
      return;
    }

    if (this.stepper && this.stepper.selectedIndex > 0) {
      this.stepper.selectedIndex = 0;
    }
  }

  nextUsers(component: UsersComponent, stepper: MatStepper) {
    this.usersArr = component.listItem;
    this.usersArr = this.usersArr.map((user: any) => ({ ...user }));


    //Validate section
    if (!this.usersArr || this.usersArr.length === 0) {
      this.isSectionsValid = false;
      this.errorMessage = this.variables.minimumUsers;
      this.infoBar.showSnackbar(this.errorMessage, ['error-snackbar'], 4000);
    } else {
      this.isSectionsValid = true
      this.formGroup1.status = "VALID";
      this.usersService.setListItem(this.usersArr);
      stepper.next();
    }
  }

  //Activate after the click on 'Proximo' for the project type section. Check to see if the section is valid so that the user can carry on.
  nextProjectType(component: TipoProjetoComponent, stepper: MatStepper) {
    //Define project type list
    this.projectTypeArr = component.listItem;

    //Validate section
    if (this.projectTypeArr.length === 0) {
      this.isSectionsValid = false;
      this.errorMessage = this.variables.atLeastOneProjectTypeMessage + '.';
      this.infoBar.showSnackbar(this.errorMessage, ['error-snackbar'], 4000);
    } else {
      this.isSectionsValid = true
      this.formGroup1.status = "VALID";
      this.projectTypesService.setListItem(component.listItem);
      stepper.next();
    }

  }

  //Activate after the click on 'Proximo' for the configuration section. Check to see if the section is valid so that the user can carry on.
  nextConfiguration(component: ConfigurationComponent, stepper: MatStepper) {
    //Define configuration and parameters list
    this.configurationArr = component.listItem;
    this.paramsArr = component.listItemParams;

    //Validate section
    //if (this.configurationArr.length === 0) {
    //  this.isSectionsValid = false;
    //  this.errorMessage = this.variables.atLeastOneConfig + '.'
    //  this._snackBar.open(this.errorMessage);
    //} else {
    this.isSectionsValid = true;
    this.formGroup4.status = "VALID";
    stepper.next();
    // }
  }

  //Activate after the click on 'Proximo' for the configuration section. Check to see if the section is valid so that the user can carry on.
  nextMacro(component: MacroactivityComponent, stepper: MatStepper) {
    //Define macro activities list
    this.macroActivitiesArr = component.listItem;

    //Validate section
    if (this.macroActivitiesArr.length === 0) {
      this.isSectionsValid = false;
      this.errorMessage = this.variables.atLeastOneMethodology + '.'
      this.infoBar.showSnackbar(this.errorMessage, ['error-snackbar'], 4000);
      return;
    }
    //Validate macroactivities
    if (this.macroActivitiesArr.some((item: any) => item.macroActivities.length === 0)) {
      this.isSectionsValid = false;
      this.errorMessage = this.variables.atLeastOneMacro + '.'
      this.infoBar.showSnackbar(this.errorMessage, ['error-snackbar'], 4000);
    } else {
      this.isSectionsValid = true;
      this.formGroup5.status = "VALID";
      stepper.next();
    }
  }

  //Activate after the click on 'Proximo' for the configuration section. Check to see if the section is valid so that the user can carry on.
  nextAction(component: CatalogComponent, stepper: MatStepper) {
    //Define macro activities list
    this.actionItemsArr = component.listItemActions;

    //Validate section
    if (!this.actionItemsArr || this.actionItemsArr.length === 0) {
      this.isSectionsValid = false;
      this.errorMessage = this.variables.atLeastOneAction + '.'
      this.infoBar.showSnackbar(this.errorMessage, ['error-snackbar'], 4000);
    } else {
      this.isSectionsValid = true;
      this.formGroup6.status = "VALID";
      stepper.next();
    }
  }

  /* saiu o campo projectRiskComponent: ProjectRiskComponent dentro da função abaixo */
  saveFromSection(usersComponent: UsersComponent,
    tipoProjetoComponent: TipoProjetoComponent,
    configurationComponent: ConfigurationComponent,
    macroActivityComponent: MacroactivityComponent,
    catalogComponent: CatalogComponent,
    subTaskComponent: SubTasksComponent,
    stepper: MatStepper) {

    //-- Get current state of every section --
    //Define project risk list
    //this.projectRiskArr = projectRiskComponent.listItem;
    //Define project type list
    this.usersArr = usersComponent.listItem.map((user: any) => ({ ...user }));

    this.projectTypeArr = tipoProjetoComponent.listItem;
    //Define configuration and parameters list
    this.configurationArr = configurationComponent.listItem;
    this.paramsArr = configurationComponent.listItemParams;
    //Define macro activities list
    this.macroActivitiesArr = macroActivityComponent.listItem;
    //Define action item list
    this.actionItemsArr = catalogComponent.listItemActions;
    //Define sub-tasks list
    this.subTasksArr = subTaskComponent.listSubTasks;

    /* saiu o campo this.projectRiskArr abaixo */
    this.validateLists(this.usersArr, this.projectTypeArr, this.macroActivitiesArr, this.actionItemsArr, this.subTasksArr);

    /* special case: every methododlogy must have at least 1 macro*/
    let invalidMacros = false
    this.macroActivitiesArr.forEach((item: any) => {
      if (item.macroActivities.length == 0) {
        invalidMacros = true;
      }
    });

    if (invalidMacros) {
      this.isSectionsValid = false;
      this.errorMessage = this.variables.validateMacros
      this.infoBar.showSnackbar(this.errorMessage, ['error-snackbar'], 4000);
      return;
    }

    //-- Prompt user --
    // Set message for pop up
    let local_data = {
      message: "",
      isInUse: this.isCatalogInUse,
      isCompleteOrIncomplete: this.state === CatalogState.COMPLETE ? true : false
    };

    if (stepper.selectedIndex.valueOf() >= 1 && this.state === CatalogState.COMPLETE && this.actionItemsArr != null) {
      local_data.message = this.variables.techCompleteImcomplete;
      local_data.isCompleteOrIncomplete = true;
      if (this.isCatalogInUse)
        local_data.message = this.variables.techUsedComplete;
    } else {
      local_data.message = this.state === CatalogState.COMPLETE ? this.variables.saveTechMessage : this.variables.sectionsNotCompleteMessage
    }


    // Open pop up
    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: local_data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.data) {
        if (result.isComplete === undefined) {
          this.state = CatalogState.INCOMPLETE;  // Ensure the state is set before saving
          this.saveAction(stepper);
        } else {
          this.state = result.isComplete ? CatalogState.COMPLETE : CatalogState.INCOMPLETE;
          this.saveAction(stepper);
        }
      }
    });

  }

  // Method to reset form groups
  resetFormGroups() {
    this.formGroup0.reset();
    this.formGroup1.reset();
    this.formGroup2.reset();
    this.formGroup3.reset();
    this.formGroup4.reset();
    this.formGroup5.reset();
    this.formGroup6.reset();
    this.formGroup7.reset();
  }

  private resetStepperStateForCatalogSelection() {
    this.resetFormGroups();
    this.stepper?.reset();
    this.isSectionsValid = true;
    this.errorMessage = '';
    this.macroTypes = [];
    this.selectedTech = '';
    this.selectedName = '';
    this.selectedRegion = '';
    this.costCenter = '';
    this.selectedTechnology = this.createEmptySelectedTechnology();
  }

  //Check every list from every section. If the user has at least one item in each list the technology is complete, otherwise is declared as incomplete.
  //saiu o campo projectRiskArr: any[], abaixo no validateLists
  validateLists(usersArr: any[], projectTypeArr: any[], macroActivitiesArr: any[], actionItemsArr: any[], subTasksArr: any[]) {
    //retirada a condição projectRiskArr.length == 0 ||  - abaixo

    if (usersArr.length <= 0 || projectTypeArr.length <= 0 || macroActivitiesArr.length <= 0 || actionItemsArr.length <= 0 || subTasksArr.length <= 0) {
      this.state = CatalogState.INCOMPLETE;
    } else {
      this.state = CatalogState.COMPLETE;
    }

  }

  saveAction(stepper: MatStepper) {
    //In case new technology is being created it will send a POST request
    if (this.isNewTechnology) {
      this.technologyDocument = {
        technology: this.selectedTech,
        name: this.selectedName,
        region: this.selectedRegion,
        costCenter: this.costCenter,
        state: this.state,
        catalogType: 1,
        users: this.usersArr,
        projectTypes: this.projectTypeArr,
        configurations: this.configurationArr,
        parameters: this.paramsArr,
        macroActivities: this.macroActivitiesArr,
        actionItems: this.actionItemsArr,
        subTasks: this.subTasksArr
      };
      this.technologyService.addTecnologia(this.technologyDocument).subscribe
        ({
          next: (data) => {
            if (data) {

              this.infoBar.showSnackbar(this.variables.catalogAddedSuccessfully, ['successful-snackbar'], 4000);

              this.resetFormGroups();
              stepper.reset();
              this.isStepperReset = true;
              this.selectedTech = '';
              this.selectedName = '';
              this.selectedRegion = '';
              stepper.selectedIndex = 0; // Redirect to the first step of the stepper

              this.router.navigate(['/management'], { queryParams: { id: 'generic', hasUpdates: true } });
            }
          },
          error: (error) => {
            const msg = error.error.message.trim()
            console.error('Error:', error.error);

            const message = this.errorMessages[msg]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        });
    }
    //In case a technology is being updated it will send a PUT request
    else {

      this.technologyDocument = {
        id: this.selectedTechnology.catalogID,
        technologyId: this.selectedTechnology.technologyId,
        name: this.selectedName ? this.selectedName : this.selectedTechnology.name,
        region: this.selectedRegion,
        costCenter: this.costCenter,
        state: this.state,
        catalogType: 1,
        users: this.usersArr,
        projectTypes: this.projectTypeArr,
        configurations: this.configurationArr,
        parameters: this.paramsArr,
        macroActivities: this.macroActivitiesArr,
        actionItems: this.actionItemsArr,
        subTasks: this.subTasksArr
      };

      this.technologyService.updateCatalog(this.technologyDocument, this.selectedTechnology.catalogID).subscribe
        ({
          next: (data) => {
            if (data) {

              this.resetFormGroups();
              stepper.reset();
              this.isStepperReset = true;
              this.selectedTech = '';
              this.selectedName = '';
              this.selectedRegion = '';
              stepper.selectedIndex = 0; // Redirect to the first step of the stepper

              this.infoBar.showSnackbar(this.variables.catalogUpdatedSuccessfully, ['successful-snackbar'], 4000);

            }
          },
          error: (error) => {
            const msg = error.error.message.trim()
            console.error('Error:', error.error);

            const message = this.errorMessages[msg]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        });
    }
  }

  // Event is emited from child. It cointains the selected technology in step 1.
  selectTech(event: any) {
    if (!event) {
      this.resetStepperStateForCatalogSelection();
      return;
    }

    const previousCatalogId = this.selectedTechnology?.catalogID;
    const hasCatalogChanged = previousCatalogId && previousCatalogId !== event.catalogID;

    if (hasCatalogChanged) {
      this.resetStepperStateForCatalogSelection();
    }

    this.selectedTechnology = event
    console.log(this.selectedTechnology);

    // Set canEditCatalog from backend response (SUPER_ADMIN or owner)
    this.canEditCatalog = event.edit === true;

    this.isCatalogUsed()

    this.checkCatalogUser(event.users)

    this.macroTypes = [];

    if (event.macroActivities != null) {
      event.macroActivities.forEach((macro: any) => {
        if (!this.macroTypes.includes(macro.type)) {
          this.macroTypes.push(macro.type);
        }
      })
    }
  }

  isCatalogUsed() {
    this.catalogService.isCatalogUsed(this.selectedTechnology.catalogID).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        return throwError(() => err);
      })
    ).subscribe({
      next: (data: boolean) => {
        try {
          this.isCatalogInUse = data;
          console.log(this.isCatalogInUse);
        } catch (err) {
          console.error('Error processing data:', err);
        }
      },
    });
  }

  // Event is emited from child. It will determine if the technology is beind created or updated.
  AddOrUpdateTechnolgy(event: boolean) {
    this.isNewTechnology = event;
  }

  // Leave backoffice functionality.
  leave() {
    // Set message for pop up
    let local_data = {
      message: this.variables.sureOutMesage
    }

    // Open pop up
    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: local_data
    });

    dialogRef.afterClosed().subscribe(result => {

      //Leave backoffice
      if (result.data) {
        this.router.navigate(['/dashboard']);
      }

    });
  }

  nextStep(event: any, stepper: MatStepper) {
    stepper.next();

    this.isStepperReset = false;

    if (this.selectedTechnology.name) {
      this.selectedName = this.selectedTechnology.name;
    }
    if (this.selectedTechnology.techName || this.selectedTechnology.technology) {
      this.selectedTech = this.selectedTechnology.techName || this.selectedTechnology.technology;
    }
  }

}
